import styled from 'styled-components';

const Button = styled.button`
  background: #44b4a6 ;
  border: 0;
  box-shadow: 0;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -o-border-radius: 10px;
  padding: 40px 60px;
  @media screen and (max-width: 576px) {
    padding: 40px 20px;
  }

  &:hover {
    background: #3e9e92;
  }
    &:focus {
      outline: none;
    }
`;

export default Button;



// WEBPACK FOOTER //
// ./app/containers/Login/components/SubmitButton/index.js